<div id="wait" *ngIf="isLoading == 1">
    <mat-spinner></mat-spinner>
</div>

<!-- <app-basic-details  [mealMember]="memberDetails" [screentype] = "2" [selectedTab]=""></app-basic-details> -->
<app-meal-member-basic-details [memberDetail]="memberId"></app-meal-member-basic-details>
<div class="row">

    <img class="imgBack" *ngIf="this.backType < 3" (click)="backButton(this.backType)" src="assets/img/backbtn.png" />
</div>
<hr class="mt-5">
<div class="createMealDiv" *ngIf="iscreateMeal">
    <div class="row mt-5">
        <div class="col">
            <div class="title">Meal Plan Daily Targets</div>
            <div class="subTitle mt-4">Check the values on the fields</div>
            <div class="flex mt-4 targetsRow">
                <div>
                    <div>Carbs Goal</div>
                    <div>
                        <input type="number" matInput class="form-control textField textContent mt-2"
                            [(ngModel)]="carbsGoal" (ngModelChange)="recalculateDailyTarget()"
                            [ngModelOptions]="{standalone: true}" placeholder="Carbs Goal" />
                    </div>
                </div>
                <div>
                    <div>Protein Goal</div>
                    <div>
                        <input type="number" matInput class="form-control textField textContent mt-2"
                            [(ngModel)]="proteinGoal" (ngModelChange)="recalculateDailyTarget()"
                            [ngModelOptions]="{standalone: true}" placeholder="Protein Goal" />
                    </div>
                </div>
                <div>
                    <div>Fats Goal</div>
                    <div>
                        <input type="number" matInput class="form-control textField textContent mt-2"
                            [(ngModel)]="fatsGoal" (ngModelChange)="recalculateDailyTarget()"
                            [ngModelOptions]="{standalone: true}" placeholder="Fat Goal" />
                    </div>
                </div>
                <div>
                    <div>Daily Target Calories</div>
                    <div><input type="text" matInput class="form-control textField textContent mt-2 readonlyCalculated"
                            [ngModel]="dailyTarget" [ngModelOptions]="{standalone: true}" placeholder="TDEE"
                            readonly tabindex="-1" /></div>
                </div>
                <div>
                    <div>Calorie Deficit Goal</div>
                    <div>
                        <input type="number" [(ngModel)]="deficit" [ngModelOptions]="{standalone: true}"
                            placeholder="Calorie Deficit Goal" class="form-control textField textContent" />
                    </div>
                </div>


            </div>
        </div>
    </div>

    <div class="row mt-5">
        <div class="col">
            <div class="title">Meal Allocations</div>
            <div class="subTitle mt-4">Set the start and end date of the meal plan</div>
            <div class="mt-4"></div>
            <div class="flex mt-5">
                <mat-form-field>
                    <mat-label>Enter a date range</mat-label>
                    <mat-date-range-input [rangePicker]="picker" [min]="todayDate">
                        <input matStartDate placeholder="Start date" #dateRangeStart>
                        <input matEndDate placeholder="End date" #dateRangeEnd
                            (dateChange)="getSelectedDate(dateRangeStart, dateRangeEnd)">
                    </mat-date-range-input>
                    <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>
        <div class="col">
            <div class="title">Meal Plan Name</div>
            <div class="subTitle mt-4">Type the meal plan name below</div>
            <div class="mt-4"></div>
            <div class="flex mt-5">
                <div>
                    <input type="text" matInput class="form-control textField textContent mt-2"
                        [(ngModel)]="mealPlanName" [ngModelOptions]="{standalone: true}" placeholder="Type Here" />
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-md-12">
            <div class="title">Component Proportions</div>
            <div class="subTitle mt-2">Additional inputs for nutritionists/dieticians</div>
        </div>
        <div class="col-md-4 mt-3">
            <div class="mb-1 textContent" style="font-weight:600">Modification Percentage</div>
            <input type="text" class="form-control textField textContent mt-2 northStarInput" [(ngModel)]="modificationPercentage" [ngModelOptions]="{standalone: true}" placeholder="e.g. 30" />
            <div class="mb-1 textContent mt-3" style="font-weight:600">Meals allowed:</div>
            <input type="text" class="form-control textField textContent mt-2 northStarInput" [(ngModel)]="modificationMealsAllowed" [ngModelOptions]="{standalone: true}" placeholder="e.g. Breakfast,Lunch" />
        </div>
        <div class="col-md-4 mt-3">
            <div class="mb-1 textContent" style="font-weight:600">Exploration Percentage</div>
            <input type="text" class="form-control textField textContent mt-2 northStarInput" [(ngModel)]="explorationPercentage" [ngModelOptions]="{standalone: true}" placeholder="e.g. 20" />
            <div class="mb-1 textContent mt-3" style="font-weight:600">Meals allowed:</div>
            <input type="text" class="form-control textField textContent mt-2 northStarInput" [(ngModel)]="explorationMealsAllowed" [ngModelOptions]="{standalone: true}" placeholder="e.g. Dinner" />
        </div>
        <div class="col-md-4 mt-3">
            <div class="mb-1 textContent" style="font-weight:600">Plastic Wrapper Percentage</div>
            <input type="text" class="form-control textField textContent mt-2 northStarInput" [(ngModel)]="plasticWrapperPercentage" [ngModelOptions]="{standalone: true}" placeholder="e.g. 10" />
            <div class="mb-1 textContent mt-3" style="font-weight:600">Meals allowed:</div>
            <input type="text" class="form-control textField textContent mt-2 northStarInput" [(ngModel)]="plasticWrapperMealsAllowed" [ngModelOptions]="{standalone: true}" placeholder="e.g. Snack" />
        </div>
    </div>

    <hr class="mt-5">
    <div class="row mt-5">
        <div class="title col-md-12">Generate Meal For</div>
        <div class="mainSub col-md-12 mt-2">Select multiple category</div>
    </div>

    <div class="mealTypeContainer mt-4">
        <div class="mealTypeItem">
            <div class="colDivSmall" [ngClass]="{'mealActive': isEarlyMorning === 1}">
                <div class="titleNameSmall">Early morning</div>
                <div class="crossMainSmall">
                    <div class="crossSmall" (click)="removeMealType(1,'Early morning')" *ngIf="isEarlyMorningCross == 1">X</div>
                    <div class="crossSmall" (click)="addMealType(1,'Early morning')" *ngIf="isEarlyMorningCross == 2">+</div>
                </div>
            </div>
        </div>

        <div class="mealTypeItem">
            <div class="colDivSmall" [ngClass]="{'mealActive': isBreakfast === 1}">
                <div class="titleNameSmall">Breakfast</div>
                <div class="crossMainSmall">
                    <div class="crossSmall" (click)="removeMealType(2,'Breakfast')" *ngIf="isBreakCross == 1">X</div>
                    <div class="crossSmall" (click)="addMealType(2,'Breakfast')" *ngIf="isBreakCross == 2">+</div>
                </div>
            </div>
        </div>

        <div class="mealTypeItem">
            <div class="colDivSmall" [ngClass]="{'mealActive': isMidMorning === 1}">
                <div class="titleNameSmall">Mid morning</div>
                <div class="crossMainSmall">
                    <div class="crossSmall" *ngIf="isMidMorningCross == 1" (click)="removeMealType(3,'Mid morning')">X</div>
                    <div class="crossSmall" *ngIf="isMidMorningCross == 2" (click)="addMealType(3,'Mid morning')">+</div>
                </div>
            </div>
        </div>

        <div class="mealTypeItem">
            <div class="colDivSmall" [ngClass]="{'mealActive': isLunch === 1}">
                <div class="titleNameSmall">Lunch</div>
                <div class="crossMainSmall">
                    <div class="crossSmall" *ngIf="isLunchCross == 1" (click)="removeMealType(4,'Lunch')">X</div>
                    <div class="crossSmall" *ngIf="isLunchCross == 2" (click)="addMealType(4,'Lunch')">+</div>
                </div>
            </div>
        </div>

        <div class="mealTypeItem">
            <div class="colDivSmall" [ngClass]="{'mealActive': isMidEvening === 1}">
                <div class="titleNameSmall">Mid evening</div>
                <div class="crossMainSmall">
                    <div class="crossSmall" *ngIf="isMidEveningCross == 1" (click)="removeMealType(5,'Mid evening')">X</div>
                    <div class="crossSmall" *ngIf="isMidEveningCross == 2" (click)="addMealType(5,'Mid evening')">+</div>
                </div>
            </div>
        </div>

        <div class="mealTypeItem">
            <div class="colDivSmall" [ngClass]="{'mealActive': isSnack === 1}">
                <div class="titleNameSmall">Snack</div>
                <div class="crossMainSmall">
                    <div class="crossSmall" *ngIf="isSnackCross == 1" (click)="removeMealType(8,'Snack')">X</div>
                    <div class="crossSmall" *ngIf="isSnackCross == 2" (click)="addMealType(8,'Snack')">+</div>
                </div>
            </div>
        </div>

        <div class="mealTypeItem">
            <div class="colDivSmall" [ngClass]="{'mealActive': isDinner === 1}">
                <div class="titleNameSmall">Dinner</div>
                <div class="crossMainSmall">
                    <div class="crossSmall" *ngIf="isDinnerCross == 1" (click)="removeMealType(6,'Dinner')">X</div>
                    <div class="crossSmall" *ngIf="isDinnerCross == 2" (click)="addMealType(6,'Dinner')">+</div>
                </div>
            </div>
        </div>

        <div class="mealTypeItem">
            <div class="colDivSmall" [ngClass]="{'mealActive': isBedtime === 1}">
                <div class="titleNameSmall">Bedtime</div>
                <div class="crossMainSmall">
                    <div class="crossSmall" *ngIf="isBedtimeCross == 1" (click)="removeMealType(7,'Bedtime')">X</div>
                    <div class="crossSmall" *ngIf="isBedtimeCross == 2" (click)="addMealType(7,'Bedtime')">+</div>
                </div>
            </div>
        </div>
    </div>

    <hr class="mt-5">

    <div class="row mt-5">
        <div class="title">Meal and Macros breakdown</div>
    </div>

    <div class="mt-4" *ngFor="let foodType of this.meal;let i=index;">
        <div class="row mealRowBorder py-3 mb-3 align-items-end">
            <div class="col-md-2">
                <div class="mealTitle mb-2">For {{foodType.type}}</div>
            </div>
            <div class="col-md-1">
                <div class="fieldLabel">Percentage</div>
                <input type="number" class="form-control textFieldSmall textContent" [(ngModel)]="foodType.percentage" (ngModelChange)="changeDailyTarget()"
                    [ngModelOptions]="{standalone: true}" placeholder="5%" />
            </div>
            <div class="col-md-1">
                <div class="fieldLabel">Calories</div>
                <input type="text" [(ngModel)]="foodType.calories" [ngModelOptions]="{standalone: true}"
                    placeholder="kcal" class="form-control textFieldSmall textContent" />
            </div>
            <div class="col-md-1">
                <div class="fieldLabel">Protein</div>
                <input type="text" class="form-control textFieldSmall textContent"
                    [(ngModel)]="foodType.macroBreakdown.protein" [ngModelOptions]="{standalone: true}"
                    placeholder="50" />
            </div>
            <div class="col-md-1">
                <div class="fieldLabel">Carbs</div>
                <input type="text" placeholder="30" [(ngModel)]="foodType.macroBreakdown.carbs"
                    [ngModelOptions]="{standalone: true}" class="form-control textFieldSmall textContent" />
            </div>
            <div class="col-md-1">
                <div class="fieldLabel">Fat</div>
                <input type="text" class="form-control textFieldSmall textContent"
                    [(ngModel)]="foodType.macroBreakdown.fat" [ngModelOptions]="{standalone: true}"
                    placeholder="20" />
            </div>
            <div class="col-md-2">
                <div class="fieldLabel">Time</div>
                <input matInput (blur)="checkTime($event,i)" class="form-control textFieldSmall textContent"
                    [(ngModel)]="foodType.time" [ngModelOptions]="{standalone: true}" placeholder="HH:MM"
                    type="time-24" ampm={false} [ngxTimepicker]="picker" [format]="24">
                <ngx-material-timepicker #picker [format]="24"></ngx-material-timepicker>
            </div>
        </div>
    </div>


    <hr class="mt-5">

    <app-preference [allPrefer]="allPrefer" [selectedType]="checkSelectedMealType"></app-preference>
    <hr class="mt-5">

    <div class="mt-3">
     <label  class="title">Instructions</label>
     <textarea class="form-control" rows="3" style="width: 80%;" [(ngModel)]="instructions"></textarea>
    </div>

    <div class="col-md-12 mt-5 textAlign">
        <!-- Generate Meal Plan button hidden as per requirement -->
        <!-- <button class="btn btnClass1" (click)="createMealPlan(false)">Generate Meal Plan</button> -->
        <button class="btn btnClass" (click)="createMealPlan(true)">Create Meal Plan</button>
    </div>
</div>

<div class="modal fade" id="createConfirm" tabindex="-1" role="dialog" aria-labelledby="createConfirmLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content modal-size-style radius">
            <div class="modal-body text-center mt-3 modalPadding">
                <p class="modalTitle">Meal Plan Moved to Draft Section</p>
                <p class="modalSubTitle">The meal plan has been successfully relocated to the draft section, where it is
                    now available for review and edits before finalization.</p>
                <div class="mt-4">
                    <button data-bs-dismiss="modal" class="btn btnFirst btnLabel"
                        (click)="continueClick()">Continue</button>
                </div>
            </div>
        </div>
    </div>
</div>